<script>
import {getManageConfigSetting, setSystemSettingInfo} from "@/api/setting-api";
import {getFileUrl, uploadFile} from "@/utils/fileUploadUtils";

export default {
  name: "VisitorSettingPage",
  data() {
    return {
      activeName: "second",
      form2: {
        systemName: "",
      },
      form3: {
        systemLogo: "",
        fileLogoList: [],
        logoChanged: false,
      }
    }
  },// end of data

  mounted() {
    this.requiredForm()
  },

  methods: {
    onTabChange() {
      if (this.activeName === "first") {
      }
      this.requiredForm()
    },
    requiredForm() {
      getManageConfigSetting().then(({data}) => {
        console.log("getSignConfigSetting", data)
        if (data.code === 200) {
          data.data.forEach(item => {
          if (item.type === "SYSTEM_NAME") {
              let content = item.content
              if (content) {
                this.form2.systemName = content
              }
            } else if (item.type === "COMPANY_LOGO") {
              let content = item.content
              if (content !== this.form3.systemLogo || this.form3.logoChanged) {
                this.form3.systemLogo = content
                this.form3.logoChanged = false
                let url = getFileUrl(content)
                this.form3.fileLogoList = [{
                  name: "logo.png",
                  url: url
                }]
              }
            }
          })
        }
      })
    },

    onSubmitForm2() {
      if (!this.form2.systemName) {
        this.$message.error("请输入系统名称")
        return
      }
      const postData = {
        target: "MANAGE",
        type: "SYSTEM_NAME",
        content: this.form2.systemName,
        state: "VALID"
      }
      setSystemSettingInfo(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("保存成功")
          this.$store.dispatch("setupSystemSetting")
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },


    onSubmitForm3() {
      if (!this.form3.logoChanged) {
        this.$message.error("logo图未修改")
        return
      }
      if (this.form3.fileLogoList.length === 0) {
        this.$message.error("请先上传新的Logo")
        return
      }

      let companyLogo = `setting/manage/company_logo_${this.form3.fileLogoList[0].name}`
      // 等文件上传成功再落设置，避免设置已保存而图片还没落盘/上传失败的竞态
      uploadFile(this.form3.fileLogoList[0], companyLogo).then(({data}) => {
        if (data.code !== 200) {
          this.showServerErrMsg(data)
          return
        }
        this.form3.systemLogo = companyLogo
        const postData = {
          target: "MANAGE",
          type: "COMPANY_LOGO",
          content: companyLogo,
          state: "VALID"
        }
        setSystemSettingInfo(postData).then(({data}) => {
          if (data.code === 200) {
            this.$message.success("保存成功")
            this.$store.dispatch("setupSystemSetting")

          } else {
            this.showServerErrMsg(data)
          }
        }).catch((err) => {
          this.showNetErrMsg(err)
        })
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },

    handleLogoRemove(file, fileList) {
      console.log("handleLogoRemove", file, fileList);
      this.form3.fileLogoList = fileList
      this.form3.logoChanged = true
    },
    handleLogoChange(file, fileList) {
      console.log("handleLogoChange", file, fileList);
      this.form3.fileLogoList = fileList
      this.form3.logoChanged = true
    },
  }, // end of methods
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="onTabChange">

      <el-tab-pane label="系统名称" name="second">
        <el-form :model="form2"  label-position="left" label-width="80px">
          <el-form-item label="系统名称">
            <el-input v-model="form2.systemName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitForm2">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="系统Logo" name="third">
        <el-form :model="form3">
          <el-form-item label="系统Logo">
            <el-upload
                action="#"
                list-type="picture-card"
                :on-remove="handleLogoRemove"
                :on-change="handleLogoChange"
                :multiple="false"
                :file-list="form3.fileLogoList"
                :limit="1"
                :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitForm3">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped lang="less">

</style>
